import { render, staticRenderFns } from "./ReceiptEdit.vue?vue&type=template&id=2d8257e7"
import script from "./ReceiptEdit.vue?vue&type=script&lang=js"
export * from "./ReceiptEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports